/**
 * Session Expired Page
 * Landed on by SessionGate after either:
 *  - reason=expired: a silent token refresh + popup fallback both failed
 *    (AuthSessionExpiredError somewhere in the app)
 *  - reason=idle: the user was inactive past the idle timeout
 * The MSAL cache has already been cleared by the time this renders.
 */

import { useSearchParams } from 'react-router-dom';
import { loginRedirect } from '../services/authService';
import StatusScreen, { StatusPrimaryButton } from '../components/layout/StatusScreen';

const ClockIcon = (
    <svg width="30" height="30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.947-3.374L13.949 4.75c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
    </svg>
);

export default function SessionExpired() {
    const [searchParams] = useSearchParams();
    const reason = searchParams.get('reason');

    const heading = reason === 'idle' ? 'Signed Out: Inactivity' : 'Session Expired';
    const message =
        reason === 'idle'
            ? "You were signed out after a period of inactivity. Sign in again to continue where you left off."
            : 'Your session with Microsoft has expired or could not be renewed. Sign in again to continue.';

    return (
        <StatusScreen
            iconBg="#fef3c7"
            iconColor="#b45309"
            icon={ClockIcon}
            title={heading}
            subtitle={message}
            maxWidth={440}
            actions={
                <StatusPrimaryButton full onClick={() => { void loginRedirect(); }}>
                    Sign in again
                </StatusPrimaryButton>
            }
        />
    );
}
